import './DashboardCard.css';
import dayjs from 'dayjs';
const DrHistoryCard = ({ colSpan = 1, rowSpan = 2, dashboardData = {} }) => {
  const { drHistoryRangeData, drHistoryRangeLoading, drHistoryRangeError, isLoading } = dashboardData;
  
  // responseList 데이터 가져오기 - date 기준 내림차순 정렬 후 앞에서 3개만 표시
  const responseList = (drHistoryRangeData?.responseList || [])
    .sort((a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf())
    .slice(0, 3);
  
  return (
    <div 
      className="dashboard-card flex flex-col justify-between gap-8" 
    >
      <h3 className="text-b1-700 text-gray-700">최근 발령</h3>
      <div className="flex flex-col gap-3 max-h-80 overflow-y-auto flex-1">
        {isLoading || drHistoryRangeLoading ? (
          <div className="text-gray-500 text-sm">데이터를 불러오는 중...</div>
        ) : drHistoryRangeError ? (
          <div className="text-red-500 text-sm">데이터를 불러오는데 문제가 발생했습니다</div>
        ) : responseList.length > 0 ? (
          responseList.map((item, index) => (
            <div key={index} className={`dashboard-dr-history-item py-2 px-5 text-gray-600 text-b3-400 ${index === 0 ? 'bg-secondary rounded border-gray-200' : ''}`}>
              <span className="text-xs text-gray-500">{dayjs(item.date).format('YYYY-MM-DD') || '날짜 없음'}</span>
              <span>{item.startTime || 'N/A'} - {item.endTime || 'N/A'}</span>
              <span>{item.timeSlots.length / 4 || 'N/A'}시간</span>
              {
                index === 0 ? (
                  <span className="text-primary">
                    최근
                  </span>
                ) : (
                  <span className="px-6"></span>
                )
              }
            </div>
          ))
        ) : (
          <div className="text-gray-500 text-sm flex justify-center py-4">발령 데이터가 없습니다</div>
        )}
      </div>
    </div>
  );
};

export default DrHistoryCard;
